import * as Yup from "yup";
import { FormSection, ICustomInputProps } from "../interfaces/form";
import { generateValidations } from "./validations";

export const forms: { [K in FormSection]: ICustomInputProps[] } =
{
    login: [
        {
            label: "usersPage.usersForm.emailAddress",
            type: "email",
            name: "emailAddress",
            placeholder: "usersPage.usersForm.emailAddress",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.emailMinLengthError",
                    value: 3
                },
                {
                    type: "isEmail",
                    message: "usersPage.usersForm.emailPatternError"
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.emailMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.password",
            type: "password",
            name: "password",
            placeholder: "usersPage.usersForm.password",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
            ],
        },
    ],
    register: [
        {
            label: "usersPage.usersForm.firstName",
            type: "text",
            name: "firstName",
            placeholder: "usersPage.usersForm.firstName",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.firstNameMinLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.firstNameMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.lastName",
            type: "text",
            name: "lastName",
            placeholder: "usersPage.usersForm.lastName",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.lastNameMinLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.lastNameMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.emailAddress",
            type: "email",
            name: "emailAddress",
            placeholder: "usersPage.usersForm.emailAddress",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.emailMinLengthError",
                    value: 3
                },
                {
                    type: "isEmail",
                    message: "usersPage.usersForm.emailPatternError"
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.emailMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.password",
            type: "password",
            name: "password",
            placeholder: "usersPage.usersForm.password",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "pattern",
                    message: "usersPage.usersForm.passwordPatternError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.confirmPassword",
            type: "password",
            name: "confirmPassword",
            placeholder: "usersPage.usersForm.confirmPassword",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "pattern",
                    message: "usersPage.usersForm.passwordPatternError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.beehiveAssigned",
            type: "checkbox",
            name: "beehiveAssigned",
            value: false,
            validations: [
                {
                    type: "isTrue",
                    message: ""
                }
            ],
        },
        {
            label: "usersPage.usersForm.area",
            type: "select",
            name: "areaId",
            value: "",
            options: [],
            validations: [
                {
                    type: "requiredIfChecked",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        },
        {
            label: "usersPage.usersForm.acceptPrivacy",
            type: "checkbox",
            name: "privacy",
            link: "/privacy",
            linkLabel: "usersPage.usersForm.privacy",
            value: "",
            validations: [
                {
                    type: "requiredCheck",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        },
        {
            label: "usersPage.usersForm.acceptTermsAndConditions",
            type: "checkbox",
            name: "termsAndConditions",
            link: "/terms-and-conditions",
            linkLabel: "usersPage.usersForm.termsAndConditions",
            value: "",
            validations: [
                {
                    type: "requiredCheck",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        }
    ],
    addUser: [
        {
            label: "usersPage.usersForm.firstName",
            type: "text",
            name: "firstName",
            placeholder: "usersPage.usersForm.firstName",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.firstNameMinLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.firstNameMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.lastName",
            type: "text",
            name: "lastName",
            placeholder: "usersPage.usersForm.lastName",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.lastNameMinLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.lastNameMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.emailAddress",
            type: "email",
            name: "emailAddress",
            placeholder: "usersPage.usersForm.emailAddress",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.emailMinLengthError",
                    value: 3
                },
                {
                    type: "isEmail",
                    message: "usersPage.usersForm.emailPatternError"
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.emailMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.password",
            type: "password",
            name: "password",
            placeholder: "usersPage.usersForm.password",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.role",
            type: "select",
            name: "roleId",
            value: "",
            options: [],
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        },
        {
            label: "usersPage.usersForm.area",
            type: "select",
            name: "areaId",
            value: "",
            options: [],
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        }
    ],
    editUser: [
        {
            label: "usersPage.usersForm.firstName",
            type: "text",
            name: "firstName",
            placeholder: "usersPage.usersForm.firstName",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.firstNameMinLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.firstNameMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.lastName",
            type: "text",
            name: "lastName",
            placeholder: "usersPage.usersForm.lastName",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.lastNameMinLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.lastNameMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.emailAddress",
            type: "email",
            name: "emailAddress",
            placeholder: "usersPage.usersForm.emailAddress",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.emailMinLengthError",
                    value: 3
                },
                {
                    type: "isEmail",
                    message: "usersPage.usersForm.emailPatternError"
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.emailMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.role",
            type: "select",
            name: "roleId",
            value: "",
            options: [],
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        },
        {
            label: "usersPage.usersForm.area",
            type: "select",
            name: "areaId",
            value: "",
            options: [],
            disabled: false,
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                }
            ],
        }
    ],
    startChangePassword: [
        {
            label: "usersPage.usersForm.emailAddress",
            type: "email",
            name: "emailAddress",
            placeholder: "usersPage.usersForm.emailAddress",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.emailMinLengthError",
                    value: 3
                },
                {
                    type: "isEmail",
                    message: "usersPage.usersForm.emailPatternError"
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.emailMaxLengthError",
                    value: 64
                },
            ],
        },
    ],
    changePassword: [
        {
            label: "usersPage.usersForm.password",
            type: "password",
            name: "newPassword",
            placeholder: "usersPage.usersForm.password",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "pattern",
                    message: "usersPage.usersForm.passwordPatternError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.confirmPassword",
            type: "password",
            name: "confirmNewPassword",
            placeholder: "usersPage.usersForm.confirmPassword",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "pattern",
                    message: "usersPage.usersForm.passwordPatternError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
                {
                    type: "confirmNewPassword",
                    message: "usersPage.usersForm.passwordNotEquals",
                },
            ],
        },
    ],
    changeUserPassword: [
        {
            label: "usersPage.usersForm.password",
            type: "password",
            name: "password",
            placeholder: "usersPage.usersForm.password",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "pattern",
                    message: "usersPage.usersForm.passwordPatternError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "usersPage.usersForm.confirmPassword",
            type: "password",
            name: "confirmPassword",
            placeholder: "usersPage.usersForm.confirmPassword",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "usersPage.usersForm.requiredFieldError"
                },
                {
                    type: "pattern",
                    message: "usersPage.usersForm.passwordPatternError"
                },
                {
                    type: "minLength",
                    message: "usersPage.usersForm.passwordMinLengthError",
                    value: 8
                },
                {
                    type: "maxLength",
                    message: "usersPage.usersForm.passwordMaxLengthError",
                    value: 64
                },
                {
                    type: "confirmPassword",
                    message: "usersPage.usersForm.passwordNotEquals",
                },
            ],
        },
    ],
    addAlertConfiguration: [
        {
            label: "beehiveDetailsPage.tabs.alertsForm.field",
            type: "radio",
            name: "field",
            value: "",
            options: [
                {
                    value: "temperature",
                    desc: "beehiveDetailsPage.tabs.alertsForm.temperature",
                },
                {
                    value: "weight",
                    desc: "beehiveDetailsPage.tabs.alertsForm.weight",
                },
            ],
        },
        {
            label: "beehiveDetailsPage.tabs.alertsForm.minValue",
            type: "text",
            name: "minValue",
            placeholder: "beehiveDetailsPage.tabs.alertsForm.minValue",
            value: "",
            validations: [
                {
                    type: "min",
                    message: "beehiveDetailsPage.tabs.alertsForm.minValueErrorLabel",
                    value: 0
                }
            ]
        },
        {
            label: "beehiveDetailsPage.tabs.alertsForm.maxValue",
            type: "text",
            name: "maxValue",
            placeholder: "beehiveDetailsPage.tabs.alertsForm.maxValue",
            value: "",
            validations: [
                {
                    type: "min",
                    message: "beehiveDetailsPage.tabs.alertsForm.minValueErrorLabel",
                    value: 0
                }
            ]
        }
    ],
    addBeehive: [
        {
            label: "beehivesPage.form.name",
            type: "text",
            name: "name",
            placeholder: "beehivesPage.form.name",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.form.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "beehivesPage.form.minNameLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "beehivesPage.form.maxNameLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "beehivesPage.form.description",
            type: "textarea",
            name: "description",
            placeholder: "beehivesPage.form.description",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.form.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "beehivesPage.form.minDescriptionLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "beehivesPage.form.maxDescriptionLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "beehivesPage.form.owner",
            type: "select",
            name: "ownerId",
            value: "",
            options: [],
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.form.requiredFieldError"
                }
            ],
        },
        {
            label: "beehivesPage.form.externalProviderCode",
            type: "select",
            name: "externalProviderCode",
            value: "",
            options: [
                { value: "slovenia", desc: "slovenia" },
                { value: "melixa", desc: "melixa" }
            ],
            validations: [],
        },
        {
            label: "beehivesPage.form.externalProviderId",
            type: "text",
            name: "externalProviderId",
            value: "",
            validations: [],
        },
        {
            label: "beehivesPage.form.externalProviderToken",
            type: "text",
            name: "externalProviderToken",
            value: "",
            validations: [],
        },
        {
            label: "beehivesPage.form.visibility",
            type: "select",
            name: "restrictVisibilityTo",
            value: "",
            options: [
                { value: "beeTogether", desc: "Bee2gether" },
                { value: "beeDiversity", desc: "BeeDiversity" }
            ],
            validations: [],
        },
    ],
    exportStat: [
        {
            label: "beehiveDetailsPage.tabs.startDatePicker",
            type: "datepicker",
            name: "from",
            placeholder: "beehiveDetailsPage.tabs.startDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehiveDetailsPage.tabs.endDatePicker",
            type: "datepicker",
            name: "to",
            placeholder: "beehiveDetailsPage.tabs.endDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehiveDetailsPage.tabs.startingSpringDepositionIsStarting",
            type: "switch",
            name: "startingSpringDeposition",
            placeholder: "beehiveDetailsPage.tabs.startingSpringDepositionIsStarting",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.colonyStrength",
            type: "switch",
            name: "colonyStrength",
            placeholder: "beehiveDetailsPage.tabs.colonyStrength",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.broodQuality",
            type: "switch",
            name: "broodQuality",
            placeholder: "beehiveDetailsPage.tabs.broodQuality",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.stockQuality",
            type: "switch",
            name: "stockQuality",
            placeholder: "beehiveDetailsPage.tabs.stockQuality",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.eatingType",
            type: "switch",
            name: "eatingType",
            placeholder: "beehiveDetailsPage.tabs.eatingType",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.isLooting",
            type: "switch",
            name: "looting",
            placeholder: "beehiveDetailsPage.tabs.isLooting",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.isOrphanaging",
            type: "switch",
            name: "orphanage",
            placeholder: "beehiveDetailsPage.tabs.isOrphanaging",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.varroaPresence",
            type: "switch",
            name: "varroaPresence",
            placeholder: "beehiveDetailsPage.tabs.varroaPresence",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.varroaTreatmentType",
            type: "switch",
            name: "varroaTreatment",
            placeholder: "beehiveDetailsPage.tabs.varroaTreatmentType",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.varroaDeathAfterTreatmentType",
            type: "switch",
            name: "varroaDeathAfterTreatment",
            placeholder: "beehiveDetailsPage.tabs.varroaDeathAfterTreatmentType",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.stationaryInterferenceType",
            type: "switch",
            name: "stationaryInterference",
            placeholder: "beehiveDetailsPage.tabs.stationaryInterferenceType",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.otherSanitaryProblemType",
            type: "switch",
            name: "otherSanitaryProblem",
            placeholder: "beehiveDetailsPage.tabs.otherSanitaryProblemType",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.mainFlowerFlower",
            type: "switch",
            name: "mainFlower",
            placeholder: "beehiveDetailsPage.tabs.mainFlowerFlower",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.isSwarming",
            type: "switch",
            name: "swarming",
            placeholder: "beehiveDetailsPage.tabs.isSwarming",
            value: true,
        },
    ],
    exportData: [
        {
            label: "beehiveDetailsPage.tabs.startDatePicker",
            type: "datepicker",
            name: "from",
            placeholder: "beehiveDetailsPage.tabs.startDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehiveDetailsPage.tabs.endDatePicker",
            type: "datepicker",
            name: "to",
            placeholder: "beehiveDetailsPage.tabs.endDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehiveDetailsPage.tabs.alertsForm.temperature",
            type: "switch",
            name: "temperature",
            placeholder: "beehiveDetailsPage.tabs.alertsForm.temperature",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.wet",
            type: "switch",
            name: "wet",
            placeholder: "beehiveDetailsPage.tabs.wet",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.weight",
            type: "switch",
            name: "weight",
            placeholder: "beehiveDetailsPage.tabs.weight",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.flightsNumber",
            type: "switch",
            name: "flightsNumber",
            placeholder: "beehiveDetailsPage.tabs.flightsNumber",
            value: true,
        },
        {
            label: "beehiveDetailsPage.tabs.coordinates",
            type: "switch",
            name: "coordinates",
            placeholder: "beehiveDetailsPage.tabs.coordinates",
            value: true,
        }
    ],
    exportAllStat: [
        {
            label: "beehivesPage.exportForm.beehives",
            type: "multiselect-chips",
            name: "houseIds",
            value: [],
            options: [],
            typeValue: 'array',
            validations: [
                {
                    type: "isArrayRequired",
                    message: "beehivesPage.exportForm.requiredFieldError"
                }
            ],
        },
        {
            label: "beehivesPage.exportForm.startDatePicker",
            type: "datepicker",
            name: "from",
            placeholder: "beehivesPage.exportForm.startDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.exportForm.requiredFieldError"
                },
            ],
        },
        {
            label: "beehivesPage.exportForm.endDatePicker",
            type: "datepicker",
            name: "to",
            placeholder: "beehivesPage.exportForm.endDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehivesPage.exportForm.startingSpringDepositionIsStarting",
            type: "switch",
            name: "startingSpringDeposition",
            placeholder: "beehivesPage.exportForm.startingSpringDepositionIsStarting",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.colonyStrength",
            type: "switch",
            name: "colonyStrength",
            placeholder: "beehivesPage.exportForm.colonyStrength",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.broodQuality",
            type: "switch",
            name: "broodQuality",
            placeholder: "beehivesPage.exportForm.broodQuality",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.stockQuality",
            type: "switch",
            name: "stockQuality",
            placeholder: "beehivesPage.exportForm.stockQuality",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.eatingType",
            type: "switch",
            name: "eatingType",
            placeholder: "beehivesPage.exportForm.eatingType",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.isLooting",
            type: "switch",
            name: "looting",
            placeholder: "beehivesPage.exportForm.isLooting",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.isOrphanaging",
            type: "switch",
            name: "orphanage",
            placeholder: "beehivesPage.exportForm.isOrphanaging",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.varroaPresence",
            type: "switch",
            name: "varroaPresence",
            placeholder: "beehivesPage.exportForm.varroaPresence",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.varroaTreatmentType",
            type: "switch",
            name: "varroaTreatment",
            placeholder: "beehivesPage.exportForm.varroaTreatmentType",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.varroaDeathAfterTreatmentType",
            type: "switch",
            name: "varroaDeathAfterTreatment",
            placeholder: "beehivesPage.exportForm.varroaDeathAfterTreatmentType",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.stationaryInterferenceType",
            type: "switch",
            name: "stationaryInterference",
            placeholder: "beehivesPage.exportForm.stationaryInterferenceType",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.otherSanitaryProblemType",
            type: "switch",
            name: "otherSanitaryProblem",
            placeholder: "beehivesPage.exportForm.otherSanitaryProblemType",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.mainFlowerFlower",
            type: "switch",
            name: "mainFlower",
            placeholder: "beehivesPage.exportForm.mainFlowerFlower",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.isSwarming",
            type: "switch",
            name: "swarming",
            placeholder: "beehivesPage.exportForm.isSwarming",
            value: true,
        }
    ],
    exportAllData: [
        {
            label: "beehivesPage.exportForm.beehives",
            type: "multiselect-chips",
            name: "houseIds",
            value: [],
            options: [],
            typeValue: 'array',
            validations: [
                {
                    type: "isArrayRequired",
                    message: "beehivesPage.exportForm.requiredFieldError"
                },
            ],
        },
        {
            label: "beehivesPage.exportForm.startDatePicker",
            type: "datepicker",
            name: "from",
            placeholder: "beehivesPage.exportForm.startDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehivesPage.exportForm.endDatePicker",
            type: "datepicker",
            name: "to",
            placeholder: "beehivesPage.exportForm.endDatePicker",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "beehivesPage.tabs.requiredFieldError"
                },
            ],
        },
        {
            label: "beehivesPage.exportForm.temperature",
            type: "switch",
            name: "temperature",
            placeholder: "beehivesPage.exportForm.temperature",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.wet",
            type: "switch",
            name: "wet",
            placeholder: "beehivesPage.exportForm.wet",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.weight",
            type: "switch",
            name: "weight",
            placeholder: "beehivesPage.exportForm.weight",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.flightsNumber",
            type: "switch",
            name: "flightsNumber",
            placeholder: "beehivesPage.exportForm.flightsNumber",
            value: true,
        },
        {
            label: "beehivesPage.exportForm.coordinates",
            type: "switch",
            name: "coordinates",
            placeholder: "beehivesPage.exportForm.coordinates",
            value: true,
        }
    ],
    addBeehiveStats: [],
    addArea: [
        {
            label: "areasExpertisePage.areaForm.name",
            type: "text",
            name: "name",
            placeholder: "areasExpertisePage.areaForm.name",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "areasExpertisePage.areaForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "areasExpertisePage.areaForm.minNameLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "areasExpertisePage.areaForm.maxNameLengthError",
                    value: 64
                },
            ],
        },
        {
            label: "areasExpertisePage.areaForm.manager",
            type: "select",
            name: "managerId",
            value: "",
            options: [],
            validations: [
                {
                    type: "required",
                    message: "areasExpertisePage.areaForm.requiredFieldError"
                }
            ],
        },
    ],
    addRole: [
        {
            label: "permissionsPage.permissionsForm.name",
            type: "text",
            name: "name",
            placeholder: "permissionsPage.permissionsForm.name",
            value: "",
            validations: [
                {
                    type: "required",
                    message: "permissionsPage.permissionsForm.requiredFieldError"
                },
                {
                    type: "minLength",
                    message: "permissionsPage.permissionsForm.minNameLengthError",
                    value: 3
                },
                {
                    type: "maxLength",
                    message: "permissionsPage.permissionsForm.maxNameLengthError",
                    value: 64
                },
            ],
        }
    ]
}

export const getForm = <T>(section: FormSection) => {

    let initialValues: { [key: string]: any } = {};

    let validationsFields: { [key: string]: any } = {};

    for (const field of forms[section]) {
        initialValues[field.name] = field.value;
        if (!field.validations) continue;
        const schema = generateValidations(field)
        validationsFields[field.name] = schema;
    }

    return {
        validationSchema: Yup.object({ ...validationsFields }),
        initialValues: initialValues as T,
        inputs: forms[section],
    };

};